import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { object, string } from 'yup';
var MIN = 'min';
var MAX = 'max';
var ONE_SPECIAL_CHAR = 'one_special_char';
var ONE_UPPERCASE_AND_LOWERCASE_CHAR = 'one_uppercase_and_lowercase_char';
var ONE_NUMBER = 'one_number';
export var PASSWORD_VALIDATION_OBJECT = string().required().min(8, MIN).max(32, MAX).matches(/\W/, ONE_SPECIAL_CHAR).matches(/(?=.*[a-z])(?=.*[A-Z])/, ONE_UPPERCASE_AND_LOWERCASE_CHAR).matches(/\d/, ONE_NUMBER); // Validation schema to be used by Formik.

export var generatePasswordValidationSchema = function generatePasswordValidationSchema(field) {
  var schema = _defineProperty({}, field, PASSWORD_VALIDATION_OBJECT);

  return object().shape(schema);
};
export var passwordErrorMap = [{
  label: MIN,
  message: 'Minimum 8 characters'
}, {
  label: ONE_SPECIAL_CHAR,
  message: 'One special character'
}, {
  label: ONE_UPPERCASE_AND_LOWERCASE_CHAR,
  message: 'One uppercase and lowercase character'
}, {
  label: ONE_NUMBER,
  message: 'One number'
}]; // Helper to handle custom error states for dynamic password field.

export var determinePasswordErrorState = function determinePasswordErrorState(formikValidationErrors, customValidationErrors, passwordLength) {
  var state = false;

  if (customValidationErrors && formikValidationErrors) {
    state = true;
  } else {
    if (customValidationErrors) {
      state = passwordLength > 0 ? true : false;
    }

    if (formikValidationErrors) {
      state = passwordLength > 0 ? false : true;
    }
  }

  return state;
};